// extracted by mini-css-extract-plugin
export default {"imgTag":"Tag_imgTag__ViAnP","tagDeleteBtn":"Tag_tagDeleteBtn__lz-gD"};